import styled from "styled-components";

const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

const UserProfileWrapper = styled.div`
	display: flex;
	gap: 15px;
	align-items: center;
	margin-bottom: 20px;
	padding: 0 10px;
`;

const UserProfile = styled.div`
	display: flex;
	flex-direction: column;
`;

const Username = styled.div`
	align-items: center;
	display: flex;
	color: var(--content-text-color);
	text-align: start;
	font-size: 24px;
	font-weight: 600;
	line-height: 32px;
	letter-spacing: 0.75px;
`;

const UserIdWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
`;

const UserIdTitle = styled.div`
	display: flex;
	align-items: center;
	color: var(--secondary-text-color);
	text-align: center;
	font-size: 14px;
	font-weight: 800;
	line-height: 28px;
	letter-spacing: 0.3px;
`;

const UserId = styled.div`
	display: flex;
	align-items: center;
	color: var(--secondary-text-color);
	text-align: center;
	font-size: 14px;
	font-weight: 400;
	line-height: 28px;
	letter-spacing: 0.3px;
`;

const UserTime = styled.div`
	display: flex;
	align-items: center;
	color: var(--secondary-text-color);
	text-align: center;
	font-size: 12px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.3px;
`;

const LastLoginTime = styled.div`
	display: flex;
	align-items: center;
	color: var(--secondary-text-color);
	text-align: center;
	font-size: 12px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.3px;
	margin-top: 4px;
`;

const LastLoginIp = styled.div`
	display: flex;
	align-items: center;
	color: var(--secondary-text-color);
	text-align: center;
	font-size: 12px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.3px;
	margin-top: 2px;
`;

export {
	ContentWrapper,
	LastLoginIp,
	LastLoginTime,
	UserId,
	UserIdTitle,
	UserIdWrapper,
	Username,
	UserProfile,
	UserProfileWrapper,
	UserTime,
};
